/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Save_ReviewInputs */

const en_us2_auth_save_review = /** @type {(inputs: Auth_Save_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review my answers`)
};

const pt_br2_auth_save_review = /** @type {(inputs: Auth_Save_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar respostas`)
};

const es_419_auth_save_review = /** @type {(inputs: Auth_Save_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar respuestas`)
};

const pt_pt2_auth_save_review = /** @type {(inputs: Auth_Save_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rever respostas`)
};

const fr_fr2_auth_save_review = /** @type {(inputs: Auth_Save_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoir mes réponses`)
};

const de_de2_auth_save_review = /** @type {(inputs: Auth_Save_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten prüfen`)
};

const it_it2_auth_save_review = /** @type {(inputs: Auth_Save_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi le risposte`)
};

/**
* | output |
* | --- |
* | "Review my answers" |
*
* @param {Auth_Save_ReviewInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_save_review = /** @type {((inputs?: Auth_Save_ReviewInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Save_ReviewInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_save_review(inputs)
	if (locale === "es-419") return es_419_auth_save_review(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_save_review(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_save_review(inputs)
	if (locale === "de-DE") return de_de2_auth_save_review(inputs)
	if (locale === "it-IT") return it_it2_auth_save_review(inputs)
	return en_us2_auth_save_review(inputs)
});
export { auth_save_review as "auth.save_review" }